<template>
  <div>
    <yd-cell-group v-show="searchDiv">
      <yd-cell-item>
        <yd-icon slot="icon" name="phone3" size=".45rem"></yd-icon>
        <input type="text" slot="right" v-model="phone" placeholder="请输入手机号码">
      </yd-cell-item>
      <yd-cell-item v-show="codeOpen">
        <yd-icon slot="icon" name="verifycode" size=".45rem"></yd-icon>
        <input type="text" slot="right" v-model="code" placeholder="请输入验证码">
        <yd-sendcode slot="right"
                     v-model="codeStatus"
                     storage-key="hahaha1"
                     @click.native="sendCode"
                     type="warning"
        ></yd-sendcode>
      </yd-cell-item>
      <yd-button size="large" type="primary" @click.native="orderSearch" v-preventReClick>提交</yd-button>
    </yd-cell-group>
    <div v-for="(item, key) in orderList" :key="key" class="order_section" style="color: black">
      <yd-flexbox class="order_number">
        <yd-flexbox-item>订单号</yd-flexbox-item>
        <yd-flexbox-item class="number">{{item.ordersn}}</yd-flexbox-item>
      </yd-flexbox>
      <yd-flexbox v-if="item.product_type === '22'" class="ticket_text">
        <yd-flexbox-item>门票信息</yd-flexbox-item>
      </yd-flexbox>
      <div v-if="item.product_type === '22'">
        <yd-flexbox direction="vertical">
          <yd-flexbox-item v-for="(p, key) in item.piao" :key="key" class="admission">
            <yd-flexbox>
              <yd-flexbox-item class="admission_left">{{p.goods_name}}</yd-flexbox-item>
              <yd-flexbox-item class="admission_right">{{p.goods_price}}</yd-flexbox-item>
            </yd-flexbox>
            <yd-flexbox class="order_name">
              <div>
                参会者:
                <ul>
                  <li v-for="(c, key) in p.contacts" :key="key">
                    {{c.user_name}}
                  </li>
                </ul>
              </div>
            </yd-flexbox>
          </yd-flexbox-item>
        </yd-flexbox>
      </div>
      <div v-if="item.product_type === '29'">
        <yd-flexbox direction="vertical">
          <yd-flexbox-item v-for="(p, key) in item.room" :key="key" class="admission">
            <yd-flexbox>
              <yd-flexbox-item class="admission_left">酒店名称：</yd-flexbox-item>
              <yd-flexbox-item class="admission_right">{{p.hotelname}}</yd-flexbox-item>
            </yd-flexbox>
            <yd-flexbox>
              <yd-flexbox-item class="admission_left">房间类型：</yd-flexbox-item>
              <yd-flexbox-item class="admission_right">{{p.roomtype}}</yd-flexbox-item>
            </yd-flexbox>
            <yd-flexbox>
              <yd-flexbox-item class="admission_left">入住：{{p.ruzhutime}}</yd-flexbox-item>
              <yd-flexbox-item class="admission_right">离店：{{p.likatime}}</yd-flexbox-item>
            </yd-flexbox>
            <yd-flexbox>
              <yd-flexbox-item class="admission_left">共：{{p.day}} 晚</yd-flexbox-item>
              <yd-flexbox-item class="admission_right">数量：{{p.num}}</yd-flexbox-item>
            </yd-flexbox>
            <yd-flexbox class="order_name">
              <div>
                住宿人:
                <ul>
                  <li v-for="(c, key) in p.ExhRoomorderContacts" :key="key">
                    {{c.exh_contacts_name}}
                  </li>
                </ul>
              </div>
            </yd-flexbox>
          </yd-flexbox-item>
        </yd-flexbox>
      </div>
      <yd-flexbox>
        <yd-flexbox-item>总价：<span class="order_amount">{{item.order_amount}}</span> 元</yd-flexbox-item>
        <yd-flexbox-item>优惠：<span class="order_amount">{{item.coupon_amount}}</span> 元</yd-flexbox-item>
        <yd-flexbox-item>需支付：<span class="order_amount">{{item.order_unpay}}</span> 元</yd-flexbox-item>
      </yd-flexbox>
      <yd-flexbox class="state_section">
        <yd-flexbox-item>订单状态</yd-flexbox-item>
      </yd-flexbox>
      <yd-flexbox class="state_time">
        <yd-flexbox-item>下单时间：<span>{{item.updated_at}}</span></yd-flexbox-item>
      </yd-flexbox>
      <yd-flexbox class="state_payment">
        <yd-flexbox-item>状态：<span>{{item.status_name}}</span>
        </yd-flexbox-item>
      </yd-flexbox>
      <yd-flexbox class="state_time">
        <div v-if="item.countdown && item.payway !== '3' && item.payway !== '4'">
          订单有效期：<p class="effective_period"><yd-countdown :time="item.countdown" timetype="second"></yd-countdown></p>
        </div>
      </yd-flexbox>
      <yd-flexbox class="state_payment">
        <yd-flexbox-item>
        </yd-flexbox-item>
        <yd-flexbox-item>
          <div v-if="parseInt(item.status) >= 2 && parseInt(item.status) !== 10">
            <a :href="'/'+params.id+'/fair-pay/'+item.id">支付</a>
          </div>
        </yd-flexbox-item>
      </yd-flexbox>

    </div>
  </div>
</template>

<script type="text/babel">
import axios from 'axios'

export default {
  data () {
    return {
      termList: [],
      params: this.$route.params,
      phone: '',
      code: '',
      codeOpen: false,
      searchDiv: true,
      codeStatus: false,
      orderList: []
    }
  },
  methods: {
    sendCode () {
      let res = this.checkFormat('phone')
      if (!res) {
        return false
      }
      this.$dialog.loading.open('发送中...')
      let data = {
        mobile: this.phone,
        type: 2,
        fair_id: this.params.id
      }
      axios
        .post('/user/send-sms', data)
        .then(this.sendSmsScc)
    },
    sendSmsScc (res) {
      res = res.data
      if (res.status) {
        this.codeStatus = true
        this.$dialog.loading.close()
        this.$dialog.toast({
          mes: '已发送'
        })
      } else {
        this.$dialog.loading.close()
        this.$dialog.toast({
          mes: '网络错误'
        })
      }
    },
    checkFormat (res) {
      if (res === 'phone') {
        if (this.phone === undefined || this.phone.length !== 11) {
          this.$dialog.toast({
            mes: '请填写正确的手机号'
          })
          return false
        }
      } else if (res === 'code' && this.codeOpen === true) {
        if (this.phone === undefined || this.phone.length !== 11) {
          this.$dialog.toast({
            mes: '请填写正确的手机号'
          })
          return false
        }
        if (this.code.length <= 0) {
          this.$dialog.toast({
            mes: '请填写验证码'
          })
          return false
        }
      }
      return true
    },
    orderSearch () {
      let res = this.checkFormat('code')
      if (!res) {
        return false
      }
      let data = {}
      if (this.codeOpen === false) {
        data = {fair_id: this.params.id, mobile: this.phone}
      } else {
        data = {fair_id: this.params.id, mobile: this.phone, code: this.code}
      }

      axios
        .post('/fair/check-order-details', data)
        .then(this.orderSearchSucc)
    },
    orderSearchSucc (res) {
      res = res.data
      if (res.status) {
        this.$dialog.toast({
          mes: '查询成功',
          icon: 'success',
          timeout: 1500
        })
        this.orderList = res.data.order
        this.searchDiv = false
      } else {
        this.$dialog.toast({
          mes: res.msg,
          icon: 'error',
          timeout: 1500
        })
      }
    },
    HistoryBack () {
      window.history.back()
    },
    getSetting () {
      let data = {fairid: this.params.id, type_: 'qiandaoma_close'}
      axios
        .post('/user/setting', data)
        .then(res => {
          res = res.data
          if (res.res === '1') {
            this.codeOpen = true
          }
        })
    }
  },
  mounted () {
    if (localStorage.token) {
      this.$router.push({path: '/' + this.$route.params.id + '/single-my'})
    }
    this.getSetting()
  }
}
</script>

<style lang="stylus" scoped>
  .yd-cell-box
    margin-bottom: 0.5rem
  .default
    color: red
  .order_section
    overflow: hidden
    margin-bottom: 0.4rem
  .order_section .yd-flexbox
    padding: 0.2rem 0.4rem
  .order_section .yd-flexbox.order_number
    border-bottom: 1px solid #dcdcdc
    font-size: 0.32rem
    color: #333
    position: relative
    padding-top: .3rem
    padding-bottom: .2rem
  .number
    color: #999
  .order_section .yd-flexbox.ticket_text
    font-size: 0.32rem
    color: #333
    padding-top: 0.2rem
  .order_section .title
    font-size: 0.32rem
    color: #00c800
    font-weight: bold
    text-align: left
    width: 100%
    overflow: hidden
  .order_section .admission .yd-flexbox
    padding-left: 0
    padding-right: 0
    color: #333
    font-size: 0.28rem
    padding-top: 0
  .order_section .admission_right
    text-align: right
  .order_name div
    width: 100%
    overflow: hidden
  .order_name div ul
    float: right;
  .order_name div ul li
    color: #999
    text-align: right
  .state_section
    font-size: 0.32rem
    color: #00c800
    font-weight: bold
    text-align: left
    width: 100%
    overflow: hidden
    position: relative
    margin-top: .2rem
  .order_section .yd-flexbox.state_section
    padding-top: 0.2rem
  .state_time
    font-size: 0.3rem
    padding-bottom: 0!important
  .state_time span
    float: right
    color: #909090
  .order_section .yd-flexbox.state_payment
    padding-bottom: 0.2rem
  .state_payment div
    width: 100%
    overflow: hidden
  .state_payment div a
    display: block
    padding: 0 .2rem
    float: right
    height: 0.6rem
    width: 1.56rem
    color: #04be02
    border-radius: .1rem
    text-align: center
    line-height: 0.6rem
    border: solid .02rem #04be02
  .order_amount
    color: red
  .yd-flexview
    background: none!important
  .order_number .yd-flexbox-item
    padding: 0
  .clearfix
    clear: both
  .header_top
    background: url(../../assets/image/single-my-bg.png)
    background-repeat: no-repeat
    background-size: 100%
    padding-top: 1rem
    padding-bottom: .6rem
    border-bottom-left-radius: 10%
    border-bottom-right-radius: 10%
  .header p
    text-align: center
    font-size: .32rem
  .user_name p
  .user_name button
    font-size: .24rem
    color: #fff
    line-height: .32rem
    font-family:"microsoft yahei"
    vertical-align: baseline
  .user_name
    margin-bottom: .1rem
  .head a
    color: #fff
  .head
    width: 1.8rem
    height: 1.8rem
    border: solid .04rem #fff
    border-radius: 50%
    box-sizing: border-box
    margin: 0 auto
    margin-bottom: .2rem
    text-align: center
    line-height: 1.8rem
  .order_status
    width: calc(100% - .4rem)
    margin: 0 auto
    margin-top: -.4rem
    margin-bottom: .2rem
    padding: .2rem 0
    background-color: #fff
    border-radius: .1rem
  .status
    width: calc(100% / 3)
    float: left
    text-align: center
    color: #666
    font-size: .32rem
    line-height: .4rem
    border-right: solid 1px #eee
  .status p
    color: #333
  .order_number::before
    content: ""
    width: .06rem
    height: .32rem
    background-color: #00c800
    position: absolute
    left: .2rem
    top: .34rem
    margin-top: .04rem
  .order_section .title
    margin-bottom: .2rem
  .state_section::before
    content: ""
    width: .06rem
    height: .32rem
    background-color: #00c800
    position: absolute
    left: .2rem
    top: .26rem
  .order_section
    background-color: #fff
    border-radius: .2rem
  .effective_period
    float: right
  .bottom button
    background-color: #EF4F4F!important
</style>



// WEBPACK FOOTER //
// src/views/template1/SingleCheckOrder.vue